import { computed } from 'vue'
import {
  bindTelegramEvent,
  configureBackButton,
  disableClosingConfirmation,
  enableClosingConfirmation,
  getTelegramWebApp,
  hapticFeedback,
  hideBackButton,
  hideKeyboard,
  isTelegramWebAppActive,
  openExternalLink,
  openPaymentLinkInSystemBrowser,
  openTelegramLink,
  shareViaTelegram,
  openInvoice,
  unbindTelegramEvent,
} from '@/utils/telegramWebAppClient'
import logger from '@/utils/logger'

/**
 * Telegram WebApp composable — thin wrapper over the shared client singleton.
 * Viewport/fullscreen init is handled once in App.vue.
 */
export function useTelegramWebApp() {
  const webApp = computed(() => getTelegramWebApp())
  const isAvailable = computed(() => isTelegramWebAppActive())

  const checkEnvironment = () => isTelegramWebAppActive()

  const getInitData = () => webApp.value?.initData || null

  const showMainButton = (text, onClick) => {
    if (!webApp.value?.MainButton) return false

    try {
      const mainButton = webApp.value.MainButton
      mainButton.setText(text)
      if (onClick) {
        mainButton.onClick(onClick)
      }
      mainButton.show()
      return true
    } catch (error) {
      logger.warn('MainButton not available:', error)
      return false
    }
  }

  const hideMainButton = () => {
    if (!webApp.value?.MainButton) return false

    try {
      webApp.value.MainButton.hide()
      return true
    } catch (error) {
      logger.warn('MainButton not available:', error)
      return false
    }
  }

  return {
    isAvailable,
    webApp,
    checkEnvironment,
    getInitData,
    hapticFeedback,
    configureBackButton,
    hideBackButton,
    hideKeyboard,
    openExternalLink,
    openPaymentLinkInSystemBrowser,
    openTelegramLink,
    shareViaTelegram,
    openInvoice,
    bindTelegramEvent,
    unbindTelegramEvent,
    enableClosingConfirmation,
    disableClosingConfirmation,
    showMainButton,
    hideMainButton,
  }
}
